<template>
  <div class="group relative flex bg-white rounded mb-4 shadow-md last:mb-0">
    <div class="relative w-[308px] h-[248px] rounded">
      <nuxt-link :to="url" :title="data.name">
        <el-image
          :class="$style.product_img"
          :src="data.image"
          fit="cover"
          :alt="data.name"
        />
      </nuxt-link>
      <template v-if="loggedIn">
        <el-image
          v-if="isFavorite"
          alt="取消收藏"
          :class="$style.product_collect"
          lazy
          @click="onToggleFavorite"
          fit="cover"
          src="~@/assets/img/resource/collected-icon.png"
        />
        <el-image
          alt="收藏"
          v-else
          :class="$style.product_collect"
          lazy
          @click="onToggleFavorite"
          fit="cover"
          src="~@/assets/img/resource/collect-icon.png"
        />
      </template>
    </div>
    <div class="flex-1 ml-1 px-4 py-6">
      <div class="flex relative">
        <h3
          class="text-xl font-medium text-dark line-clamp-2 transition-colors group-hover:text-primary"
        >
          <ProductLevelIcon v-if="data.level_pic" :icon="data.level_pic" />
          <nuxt-link :to="url" :title="data.name">{{ data.name }}</nuxt-link>
        </h3>
      </div>
      <div class="mb-3 pr-[200px] pb-10">
        <div v-if="data.tags" class="my-2">
          <span
            class="inline-flex text-xs text-[#7378E6] border border-current bg-opacity-20 px-1 rounded-sm"
            v-for="(tag, index) in data.tags"
            :class="{
              'ml-2': index > 0,
            }"
            >{{ tag }}</span
          >
        </div>
        <div
          v-if="data.departure"
          class="flex mt-2 text-dark text-base leading-6"
        >
          <span class="text-xl leading-6 mr-2"
            ><i class="ficon ficon-ziyuancaigou_chufa"></i
          ></span>
          <span class="flex-1 line-clamp-2">
            <span>出发：</span>
            {{ data.departure }}
          </span>
        </div>
        <div
          v-if="data.product_date"
          class="flex mt-2 text-dark text-base leading-6 max-w-[350px]"
        >
          <span class="text-xl leading-6 mr-2"
            ><i class="ficon ficon-ziyuancaigou_chufariqi"></i
          ></span>
          <div class="flex-1">
            <VEllipsis :rows="2" symbol="查看更多">
              <span>出游日期：</span>
              {{ data.product_date }}
            </VEllipsis>
          </div>
        </div>
      </div>
      <div class="absolute right-4 bottom-6">
        <ProductItemPriceGroup
          :isDistributor="isDistributor"
          :min-sale-price="data.min_sale_price"
          :min-th-price="data.min_th_price"
        />
        <div class="flex justify-end mt-1.5">
          <el-button
            v-if="!isInShop && isDistributor && isAdmin && isOpenShop"
            class="min-w-[100px] rounded border-darker text-dark"
            icon="ficon ficon-dianpuguanlishuju mr-1"
            @click="onJoinShop"
            >加入店铺</el-button
          >
          <el-button
            v-if="isDistributor"
            class="min-w-[100px] rounded border-darker text-dark"
            icon="ficon ficon-xingzhuangjiehe2 mr-1"
            @click="handleShareShopPrdouct"
          >
            分享产品</el-button
          >
          <el-button
            class="min-w-[140px] rounded"
            type="primary"
            @click="onView"
            >查看详情</el-button
          >
        </div>
      </div>
    </div>

    <share-shop-product ref="shareShopProduct"></share-shop-product>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  useStore,
  ref,
} from "@nuxtjs/composition-api";
import { profitFormat } from "@/utils/product";
import useProductFavorite from "~/views/product/composables/useProductFavorite";
import useProductJoinShop from "~/views/product/composables/useProductJoinShop";

import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";

import VEllipsis from "~/components/VEllipsis/index.vue";
import ProductItemPriceGroup from "./product-item-price-group";
import ProductLevelIcon from "~/components/ProductLevelIcon.vue";

export default defineComponent({
  name: "ProductItem",
  components: {
    VEllipsis,
    ShareShopProduct,
    ProductItemPriceGroup,
    ProductLevelIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["collect", "join", "share", "view"],
  setup(props) {
    const depStr = computed(() =>
      props.data.city ? props.data.city.map((c) => c.city_name).join("、") : ""
    );

    const url = computed(() => `/product/vacation/${props.data.product_no}`);

    const store = useStore();
    const isDistributor = computed(() => store.getters.isDistributor);
    const isAdmin = computed(() => store.getters.isAdmin);
    const loggedIn = computed(() => store.getters.loggedIn);
    // const isFavorite = computed(() => !!props.data.is_favorite);

    const profitText = computed(() =>
      profitFormat(props.data.min_profit, props.data.max_profit)
    );
    const onView = () => {
      window.open(url.value, "_blank");
    };

    const isOpenShop = computed(() => store.getters.isOpenShop);
    const { isInShop, onJoinShop, updateJoinShopStatus } = useProductJoinShop(
      computed(() => props.data.product_no)
    );
    updateJoinShopStatus(props.data.in_shop);

    isInShop.value = props.data.in_shop;

    // ======================= 收藏 =======================
    const { isFavorite, onToggleFavorite } = useProductFavorite(
      props.data.product_no,
      !!props.data.is_favorite
    );

    // ======================= 分享 =======================
    const shareShopProduct = ref();
    const handleShareShopPrdouct = () => {
      shareShopProduct.value.handleShareShopPrdouct(props.data);
    };

    return {
      profitText,

      depStr,
      url,

      isDistributor,
      loggedIn,
      isAdmin,

      shareShopProduct,
      handleShareShopPrdouct,

      isOpenShop,
      loggedIn,
      isInShop,
      onJoinShop,

      isFavorite,
      onToggleFavorite,

      onView,
    };
  },
});
</script>

<style lang="scss" module>
.product_cover {
  border-radius: 0.25rem;
  height: 17.25rem;
  position: relative;
  width: 19.25rem;
}
.product_img {
  border-radius: 0.25rem;
  height: 100%;
  width: 100%;
}
.product_collect {
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2.5rem;
}
.product_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  margin-left: 0.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-right: 15rem;
}
.product_name {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_detail {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_detail_icon {
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 1.5rem;
  margin-right: 0.5rem;
}
.product_detail_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_price {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  -webkit-align-items: baseline;
  align-items: baseline;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}
.product_price.sale .product_price_curr {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price.sale .product_price_num {
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price_curr, .product_price_num {
  --tw-text-opacity: 1;
  color: rgba(204, 75, 12, var(--tw-text-opacity));
}
.product_price_curr {
  font-size: 1rem;
  line-height: 1.5rem;
}
.product_price_num {
  font-weight: 500;
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.product_price_unit {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-left: 0.25rem;
}
.product_profit {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 33, 41, var(--tw-bg-opacity));
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  height: 1.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1.5rem;
  margin-top: 0.25rem;
  overflow: hidden;
  border-radius: 12px 2px 12px 2px;
}
.product_profit_label {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.product_profit_value {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 169, 0, var(--tw-bg-opacity));
  font-weight: 500;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_action {
  border-radius: 0.25rem;
  min-width: 100px;
}
.product :global(.el-button--default) {
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  border: 1px solid var(--border-color-darker);
}
.product :global(.el-button--default):hover {
  border-color: var(--color-primary);
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.info_name {
  text-indent: 28px;
  margin-left: -26px;
}
.label_icon {
  height: 24px;
  width: 24px;
  margin-top: 1px;
}
.popper_class_tooltip {
  border: 1px solid #d4d7de !important;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1) !important;
  width: 248px !important;
  color: #1f2129;
  padding: 8px 10px 6px;
  margin-top: 2px !important;
  text-align: justify;
}
.title {
  font-weight: 500;
}
</style>
